<template>
  <bottomAlert :show.sync="show" class="prize-data" @close="close">
    <div
      v-if="data && Object.keys(data).length > 0 && data.type_en !== 'thanks'"
    >
      <div class="title">运气爆棚</div>
      <div class="desc">恭喜你获得{{ data.name }}</div>
      <div class="prizeImg">
        <img :src="data.img_url" />
      </div>
      <p>{{ desc }}</p>
    </div>
    <div v-else class="empty">
      <div class="desc">很遗憾，未抽中，继续努力～</div>
      <img :src="src" />
    </div>
    <button
      @click="handlerBtnClick"
      :style="{ backgroundImage: `url(${btnImg})` }"
    >
      {{ typeMap[data.type_en].btn }}
    </button>
  </bottomAlert>
</template>

<script>
import { mapState } from 'vuex';
// import prizeImg from './prizeImg';
import { isWxMiniProgram, isHllApp } from '@/utils';
export default {
  props: ['show', 'data', 'src', 'btnImg'],
  data() {
    return {
      showing: false,
      btnText: '',
      tempText: '',
      closeTag: false,
      typeMap: {
        extend: {
          btn: '开心收下'
        },
        coupon: {
          btn: '去使用'
        },
        entity: {
          btn: '填写地址'
        },
        link: {
          btn: '去使用'
        },
        cash: {
          btn: '开心收下'
        },
        wx_pack: {
          btn: '开心收下'
        },
        cdk: {
          btn: '开心收下'
        },
        thanks: {
          btn: '知道了'
        },
        undefined: {}
      }
    };
  },
  components: {
    // prizeImg
  },
  computed: {
    ...mapState('app', ['config']),
    readTip() {
      return ['extend', 'cdk'].includes(this.data.type_en);
    },
    desc() {
      if (this.data.type_en == 'coupon')
        return `有效期: ${this.data.available_period}`;
      if (this.data.type_en == 'entity') return `填写地址，奖品将尽快发出`;
      return this.data.desc;
    },
    isCDK() {
      return ['wx_pack', 'cdk'].includes(this.data.type_en);
    },
    isRedBag() {
      return ['cash', 'wx_pack', 'coupon'].includes(this.data.type_en);
    },
    drawTitle() {
      return `恭喜你获得${this.isRedBag ? this.data.money + '元' : ''}${
        this.data.name
      }`;
    }
  },
  filters: {},
  watch: {
    show: {
      handler: function(v) {
        //使红包组件的销毁,再次创建时重用默认状态
        v
          ? (this.showing = v)
          : setTimeout(() => {
              this.showing = v;
            }, 500);
      },
      immediate: true
    }
  },
  methods: {
    //按钮点击
    handlerBtnClick() {
      switch (this.data.type_en) {
        case 'extend':
          return this.handlerReceive();
        case 'coupon':
          return this.handlerOrder();
        case 'entity':
          return this.handlerContact();
        case 'link':
          return this.handlerUse(this.data.type_value);
        case 'cash':
          return this.handlerReceive();
        case 'wx_pack':
          return this.handlerReceive();
        case 'cdk':
          return this.handlerCDK();
        default:
          return this.handlerReceive();
      }
    },
    handlerOrder() {
      setTimeout(() => (location.href = `https://m.huolala.cn`), 2000); //2s后自动跳转到m站(兼容链接流露到外部的情况)
      if (isHllApp()) {
        //货拉拉app
        location.href = `hlluapp://https://0x7.me/AKsJW`;
      } else if (isWxMiniProgram()) {
        //小程序
        wx.miniProgram.navigateTo({
          url: '/pages/home/index'
        });
      }
    },
    //去使用
    handlerUse(link) {
      this.visitLog('签到页', '去使用');
      location.href = link;
    },
    //cdk
    handlerCDK() {
      this.visitLog('签到页', '复制CDK');
      if (this.data.name == '加油券') {
        this.copy(this.data.type_value);
        this.$hll.toast('兑换码已复制,正在为您跳转...');
        setTimeout(this.useOilTicket, 2000);
      } else {
        this.handlerReceive();
      }
    },
    //开心收下
    handlerReceive() {
      this.visitLog('签到页', '开心收下');
      this.close();
    },
    //填写地址
    handlerContact() {
      this.visitLog('签到页', '填写地址');
      this.$router.push('/contact');
    },
    //加油券
    useOilTicket() {
      let prefix = location.host.match(/-[^.]+/g) || '';
      let link = `https://dappweb${prefix}.huolala.cn/driver-refuel/?target_page=exchange&token=${this.config.token}`;
      location.href = link;
    },
    //copy
    copy(value) {
      /*创建一个Input元素用来存放需要复制的数据*/
      let tag = document.createElement('input');
      /*设置需要复制的内容*/
      tag.value = value;
      document.body.appendChild(tag);
      tag.select();
      /*复制到剪贴板*/
      document.execCommand('copy');
      /*完成复制，移除元素*/
      tag.value = '';
      tag.remove();
    },
    close() {
      this.$emit('update:show', false);
      //重置为默认值
      setTimeout(() => {
        this.btnText = '';
        this.tempText = '';
        this.closeTag = false;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.prize-data {
  .as_bottom {
    height: 802px;
  }
  /deep/ .as_content {
    text-align: center;
    padding-top: 30px;
    .title {
      font-size: 42px;
      color: #464857ff;
    }
    .desc {
      font-size: 40px;
      color: #e92c30ff;
    }
    .prizeImg {
      margin-top: 30px;
      img {
        width: 228px;
      }
    }
    .empty {
      img {
        width: 240px;
        margin-top: 86px;
      }
    }
    p {
      font-size: 28px;
      margin-top: 31px;
      color: #999999ff;
    }
    button {
      width: 648px;
      height: 114px;
      font-size: 40px;
      color: #fff;
      margin-top: 31px;
      background: #fff no-repeat center center;
      background-size: cover;
      border: none;
    }
  }
}
</style>
